module.exports = __webpack_public_path__ + "img/2017-09-30.7241f3eb.jpg";